/**
 * Dados NÃO sensíveis da sessão guardados no navegador (Modelo A + onda OA).
 *
 * O token de acesso NÃO fica aqui: vive num cookie httpOnly gravado pelo back, inacessível ao JavaScript
 * (padrão P-S3, src/docs/padroes-front.md). Guardamos só o que a tela precisa para abrir antes do /me
 * confirmar a sessão: empresa, filial e identificação do usuário logado.
 */
export const AUTH_STORAGE_KEYS = {
  EMPRESA_ID: 'empresaId',
  FILIAL_ID: 'filialId',
  USUARIO: 'usuarioAuth',
};

/** Chave da versão antiga (token no localStorage): apagada ao iniciar e ao sair. */
export const CHAVE_TOKEN_LEGADO = 'token';

export function removerTokenLegado() {
  try {
    localStorage.removeItem(CHAVE_TOKEN_LEGADO);
  } catch (e) {
    // armazenamento indisponível: nada a remover
  }
}

/**
 * Persiste a sessão no localStorage. Nunca grava senha nem token.
 */
export function persistirSessaoAuth({ empresaId, filialId, usuario }) {
  if (empresaId != null && empresaId !== '') {
    localStorage.setItem(AUTH_STORAGE_KEYS.EMPRESA_ID, String(empresaId));
  }
  if (filialId != null && filialId !== '') {
    localStorage.setItem(AUTH_STORAGE_KEYS.FILIAL_ID, String(filialId));
  }
  if (usuario) {
    localStorage.setItem(AUTH_STORAGE_KEYS.USUARIO, JSON.stringify(usuario));
  }
}

export function limparSessaoAuth() {
  localStorage.removeItem(AUTH_STORAGE_KEYS.EMPRESA_ID);
  localStorage.removeItem(AUTH_STORAGE_KEYS.FILIAL_ID);
  localStorage.removeItem(AUTH_STORAGE_KEYS.USUARIO);
  removerTokenLegado();
}

export function lerSessaoAuth() {
  const empresaId = localStorage.getItem(AUTH_STORAGE_KEYS.EMPRESA_ID);
  const filialId = localStorage.getItem(AUTH_STORAGE_KEYS.FILIAL_ID);
  const usuarioRaw = localStorage.getItem(AUTH_STORAGE_KEYS.USUARIO);

  let usuario = null;
  if (usuarioRaw) {
    try {
      usuario = JSON.parse(usuarioRaw);
    } catch {
      usuario = null;
    }
  }

  return {
    empresaId: empresaId || null,
    filialId: filialId || null,
    usuario,
  };
}

/** Há sessão anterior salva (a validade real é confirmada pelo GET /api/auth/me). */
export function possuiSessaoSalva() {
  const { usuario } = lerSessaoAuth();
  return Boolean(usuario && (usuario.id != null || usuario.login));
}
